require('../styles/modules/board.scss');

import React, { Component, PropTypes } from 'react'
import Goal from './Goal'
import ChallengeMakerRobot from './ChallengeMakerRobot'
import BoardCanvas from './BoardCanvas'
import ChallengeMakerFormContainer from '../containers/ChallengeMakerFormContainer'

class ChallengeMakerBoard extends Component {
  constructor(props) {
    super(props);
    this.state = { size: window.innerWidth > 700 ? 40 : 20 }
  }
  componentDidMount(){
    const { fetchChallengeId } = this.props
    var self = this;
    //TODO: debounce this
    window.onresize = this.onScreenResize.bind(this)
    fetchChallengeId()
  }
  //need to rerender board on screen resize
  onScreenResize() {
    if(window.innerWidth > 700 && this.state.size === 20){
      this.setState({
        size: 40
      })
    }
    if(window.innerWidth <= 700 && this.state.size === 40){
      this.setState({
        size: 20
      })
    }
  }
  getRobotProps(color) {
    return {
      key: color,
      size: this.state.size
    }
  }

  renderRobots() {
    const { robot } = this.props
    let robots = [];
    for(var color in robot){
      robots.push(<ChallengeMakerRobot {...robot[color]} { ...this.getRobotProps(color) }/> )
    }
    return robots
  }

  render() {
    const { size } = this.state
    const { board, goals } = this.props
    return (
      <div className = 'play-mode'>
        <div className = 'board' style={{ float: 'right', marginRight: '20px' }}>
          <BoardCanvas boardProps = { board } isMobile = { size === 20 } />
          { this.renderRobots() }
          <Goal size = { size } { ...goals }/>
        </div>
        <div className = 'challenger-maker-form'>
          <ChallengeMakerFormContainer />
        </div>
      </div>
    )
  }
}

export default ChallengeMakerBoard


// WEBPACK FOOTER //
// ./components/ChallengeMakerBoard.js